import { useMjmlStore } from "@/stores/mjmlStore";
import { useNotificationsStore } from "@/stores/notifications";
import { getPreheader } from "@/composables/text-generator/useOpenAiApi";
import { useI18n } from "vue-i18n";
import { ref } from "vue";

export default () => {
  const mjmlStore = useMjmlStore();
  const notificationsStore = useNotificationsStore();
  const { t } = useI18n();
  const preheaderGenerating = ref(false);

  const generatePreheader = async () => {
    preheaderGenerating.value = true;

    try {
      const chat = await getPreheader(
        JSON.stringify(mjmlStore.getTranslatedBlocksJson().children[0]),
        mjmlStore.authorize.apiKey,
        mjmlStore.authorize.hostname,
        mjmlStore.authorize.userId
      );

      mjmlStore.setBaseAttrTranslation({
        block: "mj-preview",
        prop: "text",
        value:
          chat.content.startsWith('"') && chat.content.endsWith('"')
            ? chat.content.slice(1, -1)
            : chat.content,
      });
      preheaderGenerating.value = false;
    } catch (err) {
      notificationsStore.createNotification({
        type: "error",
        text: t("layout.chatAI.error_generation"),
      });
      console.error(err);
      preheaderGenerating.value = false;
    }
  };

  return {
    generatePreheader,
    preheaderGenerating,
  };
};
